import { clsx } from 'clsx';
import { type FC } from 'react';

import { LayoutBlock } from '../LayoutBlock';

import { Fact, type FactTypes } from './internal/components/Fact';

import styles from './Facts.css';

type FactType = {
  title: string;
  text: string;
  type: FactTypes;
  description?: string;
};

type FactsProps = {
  isShort: boolean;
  facts: FactType[];
};

export const Facts: FC<FactsProps> = ({ facts, isShort }) => {
  return (
    <LayoutBlock id="factoids" topOffset={74}>
      <ul className={clsx(styles['container'], isShort && styles['container--short'])}>
        {facts.map((fact, index) => (
          <Fact description={fact.description} key={index} text={fact.text} title={fact.title} type={fact.type} />
        ))}
      </ul>
    </LayoutBlock>
  );
};
